/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { VendingMachinePageService } from '@pages/VendingMachinePage/services';

const getSrv = () => {
  return vappContainer.get<VendingMachinePageService>(
    VendingMachinePageService.displayName
  );
};

export const getShelves = async (context: any, event: any) => {
  const currentState = 'GET_SHELVES';
  const method = 'getShelves';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const shelves = await srv.agent.getShelves();
      if (shelves) {
        return resolve({
          key: 'RENDER_SHELVES',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'get Time not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_SHELVES_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_SHELVES_ERROR',
        value: err?.message,
      });
    }
  });
};
